var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOutlook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#158FDA",
  d: "M19.511 57.57h36.696a7.76 7.76 0 0 0 7.764-7.764V23.519c0-2.297-1.134-4.39-3.14-5.524L41.639 7.09a8.31 8.31 0 0 0-8.229 0L11.66 19.594v30.124a7.855 7.855 0 0 0 7.851 7.851"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#outlook_svg__a)",
  d: "M26.78 52.597a6.42 6.42 0 0 1 3.868-5.35s19.86-11.166 29.717-16.923c3.053-1.774 3.577-5.409 3.577-5.409v24.803a7.855 7.855 0 0 1-7.851 7.851H32.276a5.52 5.52 0 0 1-5.495-4.972"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#01459B",
  d: "M59.784 17.297 25.617 36.168l6.805 4.13c2.53 1.54 6.193 2.354 8.781.9l18.203-10.206C61.848 29.626 64 27.387 64 23.49s-2.733-5.263-4.187-6.193z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#26AEE9",
  d: "M37.743 6.044a8.85 8.85 0 0 0-4.333 1.134L4.536 23.46l10.933 6.63 33.556-18.93-6.979-3.983c-1.337-.756-2.85-1.163-4.332-1.163z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#0078D3",
  d: "M49.054 11.19 15.498 30.12l10.963 6.659 34.224-18.872c-.262-.203-.61-.378-.901-.552l-10.73-6.135z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#outlook_svg__b)",
  d: "M2.675 15.378h26.897a2.656 2.656 0 0 1 2.646 2.646l-.087 26.199a2.73 2.73 0 0 1-2.733 2.733H2.79A2.79 2.79 0 0 1 0 44.164l.087-26.228a2.563 2.563 0 0 1 2.56-2.558z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.345 26.689a7.7 7.7 0 0 1 3.024-3.373 9.85 9.85 0 0 1 4.856-1.28 9 9 0 0 1 4.536 1.047 7.67 7.67 0 0 1 3.054 3.112 9.9 9.9 0 0 1 1.134 4.623 10.9 10.9 0 0 1-.989 4.885 7.93 7.93 0 0 1-3.024 3.315c-.29.174-.61.32-.93.465a8.7 8.7 0 0 1-3.752.756 9.2 9.2 0 0 1-4.652-1.076 7.74 7.74 0 0 1-3.082-3.111 9.74 9.74 0 0 1-1.134-4.565 10.8 10.8 0 0 1 .96-4.856zm3.402 7.705c.378.873.989 1.6 1.774 2.152a4.7 4.7 0 0 0 2.704.756c1.018 0 2.036-.29 2.879-.872a4.8 4.8 0 0 0 1.657-2.21 8.4 8.4 0 0 0 .495-3.053 9.3 9.3 0 0 0-.553-3.083c-.32-.9-.901-1.657-1.657-2.238a4.62 4.62 0 0 0-2.879-.815c-.989 0-1.948.291-2.762.844a5 5 0 0 0-1.716 2.239 8.67 8.67 0 0 0 .087 6.28z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "outlook_svg__a",
  x1: 35.49,
  x2: 60.446,
  y1: 48.269,
  y2: 37.759,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4DE2FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#28AEE8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "outlook_svg__b",
  x1: 14.936,
  x2: 14.925,
  y1: 13.08,
  y2: 44.635,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1582D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0A64CC"
})))));
export default SvgOutlook;